/**
 * Applies a source array of values as arguments to the supplied "operate" function,
 * and returns the output of it.
 *
 * @param operate `(...values: T[]): R` - The function to accept all values in the source array
 * @returns `R` What "operate" returns.
 */
export const spreadInto = (operate) => values => operate(...values);
